<template>
  <div>
    <base-object :objectName="jetName" :position="position" :rotate-deg="rotateDeg"></base-object>
    <bullet-object
      v-if="shooting"
      ref='bullet'
      name='bullet'
      :initial-position="position"
      :direction="bulletDirection"
      @destroy-bullet="shooting = false"></bullet-object>
  </div>
</template>
<script>
import BaseObject from './BaseObject.vue'
import BulletObject from './BulletObject.vue'
export default {
  components: {
    BaseObject,
    BulletObject
  },
  props: {
    jetName: {
      type: String,
      required: true
    },
    initialPosition: {
      type: Object,
      required: true
    },
    initialVelocity: {
      type: Object,
      required: true
    },
    control: {
      type: Object,
      required: true
    },
    keyMap: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      velocity: {
        x: 1,
        y: 1
      },
      position: {
        x: 0,
        y: 0
      },
      rotateDeg: 0,
      shooting: false,
      bulletDirection: { x: 1, y: 1 }
    }
  },
  methods: {
    updatePostion () {
      this.position.x = this.position.x + this.velocity.x
      this.position.y = this.position.y + this.velocity.y
      this.boundaryCheck()
    },
    updateVelocity () {
      let change
      if(this.keyMap[this.control.left]) {
        change = this.velocity.x > 0 ? 0.2 : 0.1
        this.velocity.x = this.velocity.x - change
      }
      if(this.keyMap[this.control.right]) {
        change = this.velocity.x > 0 ? 0.1 : 0.2
        this.velocity.x = this.velocity.x + change
      }
      if(this.keyMap[this.control.up]) {
        change = this.velocity.y > 0 ? 0.2 : 0.1
        this.velocity.y = this.velocity.y - 0.1
      }
      if(this.keyMap[this.control.down]) {
        change = this.velocity.y > 0 ? 0.2 : 0.1
        this.velocity.y = this.velocity.y + 0.1
      }
    },
    shootingKeyPressed () {
      if(this.keyMap[this.control.shoot] && !this.shooting) {
        this.shooting = true
        let velocityMagnetude = Math.sqrt(this.velocity.y * this.velocity.y + this.velocity.x * this.velocity.x)
        this.bulletDirection = { y: (this.velocity.y / velocityMagnetude), x: (this.velocity.x / velocityMagnetude) }
      }
    },
    updateRotationDeg () {
      this.rotateDeg = Math.atan(this.velocity.y / this.velocity.x) * 180 / Math.PI
    },
    boundaryCheck () {
      if (this.position.x < 0
        || this.position.x > window.innerWidth
        || this.position.y < 0
        || this.position.y > window.innerHeight) {
        this.$emit('lost')
      }
    },
    update () {
      if (this.shooting) this.$refs.bullet.update()
      this.updatePostion()
      this.updateRotationDeg()
      this.updateVelocity()
      this.shootingKeyPressed()
      this.boundaryCheck()
    },
    reset () {
      this.initVelAndPos()
      this.shooting = false
    },
    initVelAndPos() {
      this.velocity = {x: this.initialVelocity.x, y: this.initialVelocity.y}
      this.position = {x: this.initialPosition.x, y: this.initialPosition.y}
    }
  },
  created () {
    this.initVelAndPos()
  }
}
</script>
<style></style>
